// This file includes polyfills needed by Angular 2 and is loaded before
// the app. You can add your own extra polyfills to this file.


(window as any).__Zone_enable_cross_context_check = true;

import 'zone.js/dist/zone';

import 'core-js/features/object';
import 'core-js/features/array';

import 'classlist.js';
import 'web-animations-js';

// @ts-ignore
if(Array.prototype.flatten && !Array.prototype.flat){
    // @ts-ignore
    Array.prototype.flat = Array.prototype.flatten;
}

